import { FILTER_BY_CATEGORY_KEY, SEARCH_CONFIG_KEY } from '@/constants'
import { useFilterStore, type FilterSortKey } from '@/store/app/filter'
import { Path } from '@/types'
import Vue from 'vue'
import Component from 'vue-class-component'

// eslint-disable-next-line no-use-before-define
@Component<FilterByCategoryMixin>({
  watch: {
    selectedCategory(category) {
      this.$typedStore.public.search.setFilterRecords(Boolean(category))
    },
    filterByLocationActive(isActive) {
      if (isActive) {
        // TODO: clear filter this.selectedCategory = null
      }
    },
  },
})
export default class FilterByCategoryMixin extends Vue {
  filterStore = useFilterStore()

  get sortButtons() {
    return [
      {
        icon: 'sort-alpha-down',
        sort: 'alphaDown',
      },
      {
        icon: 'sort-alpha-up',
        sort: 'alphaUp',
      },
    ] as { icon: string; sort: FilterSortKey }[]
  }

  get activeColumns() {
    return this.filterStore.activeColumns
  }

  get allColumns() {
    return this.filterStore.columns
  }

  get availableColumns() {
    return this.filterStore.columns.filter((c) => !this.activeColumns.includes(c))
  }

  resetActiveColumns() {
    for (const col of this.filterStore.activeColumns) {
      this.filterStore.removeActiveColumn(col)
    }
    for (const col of this.allColumns) {
      this.filterStore.addActiveColumn(col)
    }
  }

  get filterByCategoryConfig() {
    return FILTER_BY_CATEGORY_KEY in
      this.$typedStore.activeVisualisation.visualisationStore.app.config
      ? this.$typedStore.activeVisualisation.visualisationStore.app.config[FILTER_BY_CATEGORY_KEY]
      : {
          enable: false,
          title: '',
          label: '',
          columns: null,
        }
  }

  get title() {
    return this.filterByCategoryConfig.title
  }

  get label() {
    return this.filterByCategoryConfig.label
  }

  get columns() {
    return this.filterByCategoryConfig.columns
  }

  get searchSettingsConfig() {
    return SEARCH_CONFIG_KEY in this.$typedStore.activeVisualisation.visualisationStore.app.config
      ? this.$typedStore.activeVisualisation.visualisationStore.app.config[SEARCH_CONFIG_KEY]
      : {
          enableSearchByLocation: false,
        }
  }

  get enableSearchByLocation() {
    return this.searchSettingsConfig.enableSearchByLocation
  }

  get optionsForCategory() {
    return (category: string) => [
      { value: null, text: 'All' },
      ...this.$typedStore.visualisationData
        .fieldLeafDataUnique(Path.root, category)
        .sort()
        .map((field) => ({ value: field, text: field })),
    ]
  }

  get filterByLocationActive() {
    const { currentLocation, filterRecords } = this.$typedStore.public.search
    return (
      this.enableSearchByLocation &&
      filterRecords &&
      !this.$typedStore.activeVisualisation.visualisationStore.app.isEmpty(currentLocation)
    )
  }
}
